

























import {Component, Prop, Watch} from 'vue-property-decorator';
import Vue from 'vue';
import Parts from '@/components/Money/Parts.vue';
import Icon from '@/components/Icon.vue';
import { Tag } from '@/views/custom';

@Component({components: {Icon, Parts}})
export default class Categories extends Vue {
  @Prop() selectedTag!:Tag
  @Prop() type!: string

//better 重复
created(){
  this.$store.commit('fetchTags')
}
  get filteredList() {
    return this.$store.state.tagList.filter((tag: Tag) => tag.type === this.type)
  }

  @Watch('type')
  updateCategory() {
    if (this.type === "+") {
      this.select({name:'工资',type:'income',id:'',svg:''})
    } else{
      this.select({name:'饮食费',type:'expense',id:'',svg:''})
    }
  }
  select(tag:Tag){
    this.$emit('update:selectedTag',tag)
  }
  edit(){
    this.$router.push('/money/edit')
  }


};
